import * as React from 'react'

interface LogoProps {
  /** Rendered width in px; height scales proportionally (~3.57:1 ratio based on viewBox). */
  width?: number
  className?: string
}

/** Use on white / light-coloured backgrounds (dark ink). */
export function LogoDark({ width = 200, className }: LogoProps) {
  const h = Math.round(width / (1089.7 / 305.1))
  return (
    <svg
      width={width}
      height={h}
      viewBox="0 0 1089.7 305.1"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="STREEP"
      role="img"
      className={className}
    >
      <polygon points="0 305.1 0 173 428.3 0 428.3 132 0 305.1" fill="#BEF264" />
      <path fill="#282828" d="M707.5,263.6c7.5-1.9,13-5.7,16.5-11.5,3.5-5.8,5.2-13.9,5.2-24.3v-17c0-13.2-3-22.8-9-28.8-6-6-15.6-8.9-28.7-8.9h-79.2v132h34v-39.6h26.4l21.7,39.6h36.8l-23.6-41.5h0ZM695.2,227.7c0,7.5-3.8,11.3-11.3,11.3h-37.7v-39.6h37.7c7.5,0,11.3,3.8,11.3,11.3v17Z"/>
      <path fill="#282828" d="M846.5,199.4v-26.4h-104.7v132h104.7v-26.4h-70.7v-27.3h55.7v-26.4h-55.7v-25.5h70.7Z"/>
      <path fill="#282828" d="M962,199.4v-26.4h-104.7v132h104.7v-26.4h-70.7v-27.3h55.7v-26.4h-55.7v-25.5h70.7Z"/>
      <path fill="#282828" d="M1080.7,182c-6-6-15.6-8.9-28.7-8.9h-79.3v132h34v-37.7h45.3c13.2,0,22.8-3,28.7-9,6-6,9-15.6,9-28.7v-18.9c0-13.2-3-22.8-9-28.8h0ZM1055.8,229.6c0,7.5-3.8,11.3-11.3,11.3h-37.8v-41.5h37.8c7.5,0,11.3,3.8,11.3,11.3v18.9Z"/>
      <path fill="#282828" d="M477.5,233.5c5.8,5.8,8.7,14.8,8.7,27.2v6.7c0,13.2-3,22.8-8.9,28.8s-15.6,8.9-28.8,8.9h-77.3v-26.4h69.8c7.5,0,11.3-3.8,11.3-11.3v-14.2h-43.4c-13.2,0-22.8-3-28.7-8.9-6-6-9-15.6-9-28.8v-4.6c0-13.2,3-22.8,9-28.8,6-6,15.5-8.9,28.7-8.9h72.1v26.4h-64.5c-7.5,0-11.3,3.8-11.3,11.3v2.7c0,7.5,3.8,11.3,11.3,11.3h34c12.3,0,21.4,2.9,27.2,8.7h0Z"/>
      <polygon fill="#282828" points="601.5 173 601.5 199.4 561.9 199.4 561.9 305.1 527.9 305.1 527.9 199.4 491.7 199.4 491.7 173 601.5 173"/>
      <path fill="#282828" d="M1081.7,292.6c.4-.5.6-1.3.6-2.2v-.3c0-1.1-.3-2-.9-2.6-.6-.6-1.5-.9-2.7-.9h-7.3v10.7h4v-2.9h1.1l1.6,2.9h4.2l-1.9-3.5c.5-.2.9-.6,1.3-1.1ZM1078.2,290.7c0,.7-.3,1-1,1h-1.9v-2.6h1.9c.7,0,1,.3,1,1v.6Z"/>
      <path fill="#282828" d="M1076.5,278.6c-7.3,0-13.2,5.9-13.2,13.2s5.9,13.2,13.2,13.2,13.2-5.9,13.2-13.2-5.9-13.2-13.2-13.2ZM1076.5,301.9c-5.6,0-10.1-4.5-10.1-10.1s4.5-10.1,10.1-10.1,10.1,4.5,10.1,10.1-4.5,10.1-10.1,10.1Z"/>
    </svg>
  )
}

/** Use on black / dark-coloured backgrounds (light ink). */
export function LogoLight({ width = 200, className }: LogoProps) {
  const h = Math.round(width / (1089.7 / 305.1))
  return (
    <svg
      width={width}
      height={h}
      viewBox="0 0 1089.7 305.1"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="STREEP"
      role="img"
      className={className}
    >
      <polygon points="0 305.1 0 173 428.3 0 428.3 132 0 305.1" fill="#BEF264" />
      <path fill="#f3f3f3" d="M707.5,263.6c7.5-1.9,13-5.7,16.5-11.5,3.5-5.8,5.2-13.9,5.2-24.3v-17c0-13.2-3-22.8-9-28.8-6-6-15.6-8.9-28.7-8.9h-79.2v132h34v-39.6h26.4l21.7,39.6h36.8l-23.6-41.5h0ZM695.2,227.7c0,7.5-3.8,11.3-11.3,11.3h-37.7v-39.6h37.7c7.5,0,11.3,3.8,11.3,11.3v17Z"/>
      <path fill="#f3f3f3" d="M846.5,199.4v-26.4h-104.7v132h104.7v-26.4h-70.7v-27.3h55.7v-26.4h-55.7v-25.5h70.7Z"/>
      <path fill="#f3f3f3" d="M962,199.4v-26.4h-104.7v132h104.7v-26.4h-70.7v-27.3h55.7v-26.4h-55.7v-25.5h70.7Z"/>
      <path fill="#f3f3f3" d="M1080.7,182c-6-6-15.6-8.9-28.7-8.9h-79.3v132h34v-37.7h45.3c13.2,0,22.8-3,28.7-9,6-6,9-15.6,9-28.7v-18.9c0-13.2-3-22.8-9-28.8h0ZM1055.8,229.6c0,7.5-3.8,11.3-11.3,11.3h-37.8v-41.5h37.8c7.5,0,11.3,3.8,11.3,11.3v18.9Z"/>
      <path fill="#f3f3f3" d="M477.5,233.5c5.8,5.8,8.7,14.8,8.7,27.2v6.7c0,13.2-3,22.8-8.9,28.8s-15.6,8.9-28.8,8.9h-77.3v-26.4h69.8c7.5,0,11.3-3.8,11.3-11.3v-14.2h-43.4c-13.2,0-22.8-3-28.7-8.9-6-6-9-15.6-9-28.8v-4.6c0-13.2,3-22.8,9-28.8,6-6,15.5-8.9,28.7-8.9h72.1v26.4h-64.5c-7.5,0-11.3,3.8-11.3,11.3v2.7c0,7.5,3.8,11.3,11.3,11.3h34c12.3,0,21.4,2.9,27.2,8.7h0Z"/>
      <polygon fill="#f3f3f3" points="601.5 173 601.5 199.4 561.9 199.4 561.9 305.1 527.9 305.1 527.9 199.4 491.7 199.4 491.7 173 601.5 173"/>
      <path fill="#f3f3f3" d="M1081.7,292.6c.4-.5.6-1.3.6-2.2v-.3c0-1.1-.3-2-.9-2.6-.6-.6-1.5-.9-2.7-.9h-7.3v10.7h4v-2.9h1.1l1.6,2.9h4.2l-1.9-3.5c.5-.2.9-.6,1.3-1.1ZM1078.2,290.7c0,.7-.3,1-1,1h-1.9v-2.6h1.9c.7,0,1,.3,1,1v.6Z"/>
      <path fill="#f3f3f3" d="M1076.5,278.6c-7.3,0-13.2,5.9-13.2,13.2s5.9,13.2,13.2,13.2,13.2-5.9,13.2-13.2-5.9-13.2-13.2-13.2ZM1076.5,301.9c-5.6,0-10.1-4.5-10.1-10.1s4.5-10.1,10.1-10.1,10.1,4.5,10.1,10.1-4.5,10.1-10.1,10.1Z"/>
    </svg>
  )
}
